import React from "react";

const DataContext = React.createContext({});

export function DataProvider(props) {
  const [categories, setCategories] = React.useState();
  const [items, setItems] = React.useState();
  const [initialState, setInitialState] = React.useState(
    window.FollozeState.initialState
  );
  // const [board, setBoard] = React.useState();

  const loadData = React.useCallback(() => {
    setInitialState(window.FollozeState.initialState);
    if (window.__follozeCategoriesResult) {
      setCategories(window.__follozeCategoriesResult);
      setItems(window.__follozeItemsResult);
    }
  }, [setCategories, setItems]);

  React.useEffect(() => {
    loadData();
    window.addEventListener("FollozeDataLoaded", loadData);
    return () => {
      window.removeEventListener("FollozeDataLoaded", loadData);
    };
  }, [loadData]);

  return (
    <DataContext.Provider
      value={{
        items,
        categories,
        initialState,
      }}
    >
      {props.children}
    </DataContext.Provider>
  );
}

export const useData = () => {
  const store = React.useContext(DataContext);
  if (!store) {
    throw new Error("useData must be used within DataContext Provider");
  }
  return store;
};

export function useItemsByCategory(categoryId) {
  const { items } = useData();

  return items?.item_ids
    ?.map((itemId) => items.data[itemId])
    .filter(
      (item) =>
        (item.category_ids?.findIndex((id) => id === categoryId) ?? -1) !== -1
    );
}

export function useCategoryBySlug(slug) {
  const { categories } = useData();
  if (!categories) return;

  const categoryId = categories?.categories_ids?.find?.(
    (id) => categories.data[id].slug === slug
  );
  const category = categoryId && categories?.data[categoryId];

  return category;
}
